import React, { useCallback } from 'react';
import { Checkbox as ORCcheckbox } from '@ontruck/orc';
import { styledCheckbox } from './styled';
import { Icon, Spacer, Tooltip, Flexer } from '@ontruck/orc';
import cx from 'classnames';

const Checkbox = ({ className, value, onChange, text, infoText }) => {
  const handleCheckboxChange = useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();

      onChange(!value);
    },
    [onChange, value]
  );

  return (
    <Flexer.Parent alignItems="center">
      <div
        data-testid="checkbox"
        className={cx(className, { active: value })}
        onClick={handleCheckboxChange}
      >
        <ORCcheckbox checked={value} />
        {text}
      </div>
      {infoText && (
        <Tooltip component={infoText} skin="light" position="top">
          <Spacer mLeft="XS">
            <Icon glyph="info" name="info" size={'1.4rem'} color="primary300" />
          </Spacer>
        </Tooltip>
      )}
    </Flexer.Parent>
  );
};

export default styledCheckbox(Checkbox);
